module.exports = __webpack_public_path__ + "img/complete_24_unchecked.1f14c38b.svg";